import axios from 'axios';
import { Dispatch, SetStateAction } from 'react';
import { AnyIfEmpty } from 'react-redux';
import { EDIT_PROFILE_REQUEST, EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAILURE, RESET_PROFILE_MESSAGE } from '../constants/auth.constant';

const editProfileRequest = () => {
  return {
    type: EDIT_PROFILE_REQUEST,
  };
};

const editProfileSuccess = (data: AnyIfEmpty<object>) => {
  return {
    type: EDIT_PROFILE_SUCCESS,
    payload: data,
  };
};

const editProfileFailure = (errMsg: AnyIfEmpty<object>) => {
  return {
    type: EDIT_PROFILE_FAILURE,
    payload: errMsg,
  };
};

export const resetProfileMessage = () => {
  return {
    type: RESET_PROFILE_MESSAGE,
  };
}

export const editProfile = (profileDetails: AnyIfEmpty<object>, setToastType: Dispatch<SetStateAction<string>>, onSuccess?: () => void, setIsLoading?: Dispatch<SetStateAction<boolean>>) => {
  return async (dispatch: Dispatch<AnyIfEmpty<object>>) => {
    dispatch(editProfileRequest());
    await axios
      .patch('/visitor/edit-profile', profileDetails)
      .then((response) => {
        if (response?.data.statusCode === 200) {
          dispatch(editProfileSuccess(response.data));
          setToastType('success');
          onSuccess && onSuccess()
        } else if (response?.data.statusCode === 400) {
          dispatch(editProfileFailure(response?.data?.message))
          setIsLoading && setIsLoading(false)
          setToastType('error')
        }
      })
      .catch((err) => {
        setIsLoading && setIsLoading(false)
        dispatch(editProfileFailure(err?.response?.data?.message))
      });
  };
};

export const uploadProfilePicture = (photoUrl: string, onSuccess: (url: string) => void, onFailure: (errMsg: string) => void) => {
  return async () => {
    await axios
      .patch('/visitor/change-profile-image', { photo_url: photoUrl })
      .then((response) => {
        if (response?.data.statusCode === 200) {
          onSuccess(photoUrl)
        } else if (response?.data.statusCode === 400) {
          onFailure(response?.data?.message)
        }
      })
      .catch((err) => {
        onFailure(err?.data?.message)
      });
  };
};

export const deleteAccountRequest = (deleteAccountReason: string, onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
  return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
    axios.patch(`visitor/deletion-request`, { deleteAccountReason: deleteAccountReason })
      .then((response) => {
        if (response.data.statusCode === 200) {
          onSuccess && onSuccess(response.data?.message)
        } else {
          onFailure && onFailure(response.data?.message)
        }
      }).catch((error) => {
        onFailure && onFailure(error.response.data?.message)
      });
  };
};

export const deactivateAccountRequest = (onSuccess?: (message: string) => void, onFailure?: (message: string) => void) => {
  return (dispatch: Dispatch<AnyIfEmpty<object>>) => {
    axios.patch(`visitor/deactivate-request`)
      .then((response) => {
        if (response.data.statusCode === 200) {
          onSuccess && onSuccess(response.data?.message)
        } else {
          onFailure && onFailure(response.data?.message)
        }
      }).catch((error) => {
        onFailure && onFailure(error.response.data?.message)
      });
  };
};